export const osnTop102SIcon = {
  data: `<svg viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5"
d="M183.72 203V168H105.88C156 132.72 182.32 105 182.32 73.0799C182.32 35.84 150.68 13.4399 110.92 13.4399C84.88
13.4399 57.16 22.96 38.96 43.9599L61.64 70.2799C74.24 57.1199 90.48 48.72 111.48 48.72C127.16 48.72 142 56.8399
142 73.0799C142 96.0399 119.6 115.36 43.16 171.64V203H183.72Z" fill="#0F0125" stroke="currentColor" stroke-width="13"/></svg>`,
  name: 'top-10-2-s',
};
